export default "__VITE_ASSET__C$tlwgRh__"